<script>
import AppDisplay from '@/components/AppDisplay.vue'
import Bioinsumos from '../components/Bioinsumos.vue'
import Irrigacao from '../components/Irrigacao.vue'
import Financiamento from '../components/Financiamento.vue'
import Descricao from '../components/Descricao.vue'
import { tipoCoberturaVegetal } from '@/libs/constants/praticas/opcoesSelects'
import { formataStringYearMonthToBr } from '@/utils/utils'

export default {
  components: {
    AppDisplay,
    Bioinsumos,
    Irrigacao,
    Financiamento,
    Descricao
  },
  props: {
    praticas: {
      type: Array
    }
  },
  methods: {
    formataDataInicio (value) {
      if (!value) return ''
      return formataStringYearMonthToBr(value)
    },
    formataCulturasProdutividade (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => `• Cultura: ${value.cultura} / Produtividade: ${value.produtividade} kg`)
      return opcoesFormatadas.join('<br /> ')
    },
    formataTipoCoberturaVegetal (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.filter(v => v !== 'OUTRA').map(value => tipoCoberturaVegetal.find(opcao => opcao.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    }
  }
}
</script>

<template>
  <div>
    <el-collapse>
      <el-collapse-item v-for="(pratica, index) in praticas.filter(pratica => pratica.ano)" :key="pratica.ano + '_' + index" :title="'Ano: ' + pratica.ano">
        <div>
          <span class="title-praticas">Dados da prática</span>
          <hr />
        </div>
        <el-row>
          <el-col :span="12">
            <app-display label="Ano/Safra:" :content="pratica.ano" />
            <app-display label="Área (ha):" :content="pratica.areaDestinada" />
            <app-display label="Há rotação de culturas?" :content="pratica.hasRotacaoCulturas ? 'Sim' : 'Não'" />
            <app-display label="Cultura e produtividade:" :content="formataCulturasProdutividade(pratica.atividadesAgricolaProdutividade)" :isContentInNextLine="true" />
          </el-col>
          <el-col :span="12">
            <app-display label="Data de início da prática:" :content="formataDataInicio(pratica.dataInicio)" />
            <app-display label="Tipo de cobertura vegetal:" :content="formataTipoCoberturaVegetal(pratica.coberturasVegetais)" />
            <app-display v-if="pratica.coberturasVegetais.length && pratica.coberturasVegetais.includes('OUTRA')" label="Outro tipo de cobertura vegetal:" :content="pratica.outrosCoberturaVegetal" />

          </el-col>
        </el-row>
          <Bioinsumos :bioinsumo="{utilizaBioinsumos: pratica.utilizaBioinsumos, bioinsumos: pratica.bioinsumos}" />
          <Irrigacao :irrigacao="{possuiIrrigacao: pratica.possuiIrrigacao, ...pratica.irrigacao}" />
          <Financiamento :financiamento="{financiamentos: pratica.financiamentos, outroFinanciamento: pratica.outroFinanciamento}" />
          <Descricao :descricao="pratica.descricao" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/SPDH/SPDH.vue